<template>
  <v-flex xs12>
    <v-btn block
      id="record-btn" :class="{'active': isRecording || isJudging}"
      @mouseup="$emit('triggerRecordKey', 'keyup')"
      @mousedown="$emit('triggerRecordKey', 'keydown')">
      <v-icon v-if="isRecording"> wb_sunny</v-icon>
      <v-icon v-if="!isRecording">keyboard_voice</v-icon>
      {{getStatusText()}}
    </v-btn>
  </v-flex>
</template>
<script>
  export default {
    name: 'MicrophoneStatus',
    props: {
      isRecording: Boolean,
      isJudging: Boolean
    },
    data() {
      return {
        RECORDING_TEXT: 'RECORDING',
        RECORD_TEXT: 'RECORD',
        JUDGING_TEXT: '判讀中',
      }
    },
    methods: {
      getStatusText() {
        if (this.isRecording) return this.RECORDING_TEXT;
        if (this.isJudging) return this.JUDGING_TEXT;
        return this.RECORD_TEXT;
      }
    }

  }

</script>
<style lang="scss" scoped>
  @import '@/styles/pages/page_examinationDetail.scss';

</style>
